import React from 'react';
import './App.css';
import { Grid } from 'semantic-ui-react';
import SidePanel from './SidePanel/SidePanel';
import MetaPanel from './MetaPanel/MetaPanel';
import Messages from './Messages/Messages';
import ColorPanel from './ColorPanel/ColorPanel';
import { connect } from 'react-redux';

const App = ({ currentUser, currentChannel, isPrivateChannel, userPosts }) => {
	return (
		<Grid columns='equal' className='app' style={{ background: '#eee' }}>
			<ColorPanel />
			<SidePanel
				key={currentUser && currentUser.uid}
				currentUser={currentUser}
			/>
			<Grid.Column style={{ marginLeft: 320 }}>
				<Messages
					key={currentChannel && currentChannel.id}
					currentChannel={currentChannel}
					currentUser={currentUser}
					isPrivateChannel={isPrivateChannel}
				/>
			</Grid.Column>
			<Grid.Column width={4}>
				<MetaPanel
					isPrivateChannel={isPrivateChannel}
					key={currentChannel && currentChannel.id}
					currentChannel={currentChannel}
					userPosts={userPosts}
				/>
			</Grid.Column>
		</Grid>
	);
};

const mapStateToProps = (state) => ({
	currentUser: state.user.currentUser,
	currentChannel: state.channel.currentChannel,
	isPrivateChannel: state.channel.isPrivateChannel,
	userPosts: state.channel.userPosts,
});

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App.js